import React from "react";

const BullesIcon = () => {
return (
    <svg xmlns="http://www.w3.org/2000/svg" width="50.805" height="48.753"><g transform="translate(-637 -1005)"><ellipse fill="#8BC9C3" cx="20.377" cy="17.359" rx="20.377" ry="17.359" transform="translate(647.05 1014.136)"/><path fill="#8BC9C3" d="M667.183 1045.605l9.36 8.152.864-11.537z"/><ellipse fill="#139D8B" cx="20.377" cy="17.359" rx="20.377" ry="17.359" transform="translate(637 1005)"/><path fill="#139D8B" d="M644.889 1030.816l-.658 12.392 9.62-6.424z"/></g></svg>
)}

export default BullesIcon;
